export default {"src":"/_next/static/media/repeatBlue.584b9cb2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};